(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["depict-recommendations"] && !Shopify.designMode) return;
  try {
    (function () {
  function initSection(section) {
    if (section.dataset.depictInit === '1') return;
    var grid = section.querySelector('[data-depict-recs-grid]');
    if (!grid) return;
    section.dataset.depictInit = '1';

    var prev = section.querySelector('[data-depict-rec-prev]');
    var next = section.querySelector('[data-depict-rec-next]');

    // Sets data-depict-overflow when the row scrolls (drives arrow visibility)
    // and the nav-button disabled state. Skipped while display:none
    // (clientWidth 0); the ResizeObserver re-runs it once the Depict extension
    // reveals the section.
    function update() {
      if (!grid.clientWidth) return;
      var max = grid.scrollWidth - grid.clientWidth;
      var hasOverflow = max > 1;
      var sl = Math.abs(grid.scrollLeft);
      var atStart = sl <= 1;
      var atEnd = sl >= max - 1;

      if (prev) prev.disabled = atStart;
      if (next) next.disabled = atEnd;

      if (hasOverflow) {
        section.setAttribute('data-depict-overflow', '');
      } else {
        section.removeAttribute('data-depict-overflow');
      }
    }

    // No behavior key: the grid's CSS scroll-behavior decides smooth vs instant,
    // so prefers-reduced-motion is honored without JS.
    function scrollPage(direction) {
      grid.scrollBy({ left: direction * grid.clientWidth * 0.9 });
    }
    if (prev) prev.addEventListener('click', function () { scrollPage(-1); });
    if (next) next.addEventListener('click', function () { scrollPage(1); });

    grid.addEventListener('scroll', update, { passive: true });
    grid.addEventListener('depict:recs-updated', update);
    new ResizeObserver(update).observe(grid);
    update();
  }

  function initAll(root) {
    (root || document).querySelectorAll('.depict-rec-section').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Theme editor: re-init when this section is reloaded.
  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const COMPONENT_NAME = 'footer-localization';

    if (customElements.get(COMPONENT_NAME)) return;

    class FooterLocalization extends HTMLElement {
      #form = null;
      #selects = null;
      #countrySelect = null;
      #flagImage = null;

      static FLAG_WIDTH = 22;
      static FLAG_CDN_BASE = 'https://cdn.shopify.com/static/images/flags';

      connectedCallback() {
        this.#form = this.querySelector('form');
        this.#countrySelect = this.querySelector(
          '[data-footer-localization-country-select]',
        );
        this.#flagImage = this.querySelector(
          '[data-footer-localization-flag] img',
        );
        this.#bindSelects();
      }

      disconnectedCallback() {
        this.#selects?.forEach((select) => {
          select.removeEventListener('change', this.#handleSelectChange);
        });
        this.#countrySelect?.removeEventListener(
          'change',
          this.#handleCountryPreview,
        );
      }

      #bindSelects() {
        this.#selects = Array.from(
          this.querySelectorAll('.footer-localization__select'),
        );

        for (const select of this.#selects) {
          select.addEventListener('change', this.#handleSelectChange);
        }

        this.#countrySelect?.addEventListener(
          'change',
          this.#handleCountryPreview,
        );
      }

      #handleCountryPreview = () => {
        if (!this.#countrySelect || !this.#flagImage) return;

        const selectedOption =
          this.#countrySelect.options[this.#countrySelect.selectedIndex];
        const countryCode = selectedOption.value;

        this.#flagImage.src = `${FooterLocalization.FLAG_CDN_BASE}/${countryCode.toLowerCase()}.svg?width=${FooterLocalization.FLAG_WIDTH}`;
        this.#flagImage.alt = selectedOption.textContent.trim();
      };

      #handleSelectChange = (event) => {
        if (event.currentTarget === this.#countrySelect) {
          const redirectUrl = this.#selectedRedirectUrl();

          if (redirectUrl) {
            window.location.assign(redirectUrl);
            return;
          }
        }

        this.#form?.requestSubmit();
      };

      #selectedRedirectUrl() {
        const selectedOption =
          this.#countrySelect?.options[this.#countrySelect.selectedIndex];

        return selectedOption?.dataset.redirectUrl?.trim() || '';
      }
    }

    customElements.define(COMPONENT_NAME, FooterLocalization);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const COMPONENT_NAME = 'roka-header';

    if (customElements.get(COMPONENT_NAME)) return;

    class RokaHeader extends HTMLElement {
      static CLUSTER_MIN_GAP = 24;
      static INLINE_COLLAPSE_SLACK = 96;
      static INLINE_EXPAND_SLACK = 96;
      static COMPACT_COLLAPSE_SLACK = 40;
      static COMPACT_EXPAND_SLACK = 72;
      static SEARCH_MIN_WIDTH = 196;
      static MENU_CLOSE_MS = 280;

      #menuDialog = null;
      #menuToggle = null;
      #menuSearchPanel = null;
      #mobileNavigation = null;
      #header = null;
      #inner = null;
      #start = null;
      #end = null;
      #nav = null;
      #desktopSearch = null;
      #stackedSearch = null;
      #stackedSearchInput = null;
      #icons = null;
      #pendingLayoutSync = false;
      #resizeObserver = null;
      #stickyObserver = null;
      #mediaQuery = null;
      #frameId = 0;
      #layoutMode = null;
      #isMenuClosing = false;
      #menuCloseTimer = 0;
      #menuOpenTimer = 0;

      connectedCallback() {
        this.#header = this.querySelector('[data-header]');
        this.#inner = this.querySelector('[data-header-inner]');
        this.#start = this.querySelector('[data-header-start]');
        this.#end = this.querySelector('[data-header-end]');
        this.#nav = this.querySelector('[data-header-nav]');
        this.#desktopSearch = this.querySelector('[data-header-search]');
        this.#stackedSearch = this.querySelector(
          '[data-header-stacked-search]',
        );
        this.#stackedSearchInput = this.#stackedSearch?.querySelector(
          'input[type="search"]',
        );
        this.#icons = this.querySelector('.header__icons');
        this.#menuDialog = this.querySelector('[data-header-menu-dialog]');
        this.#menuToggle = this.querySelector('[data-header-menu-toggle]');
        this.#menuSearchPanel = this.querySelector(
          '[data-header-menu-search-panel]',
        );
        this.#mobileNavigation = this.querySelector('header-mobile-navigation');
        this.#mediaQuery = window.matchMedia('(min-width: 768px)');

        this.#menuToggle?.addEventListener('click', this.#toggleMenu);
        this.#menuDialog?.addEventListener('click', this.#handleDialogClick);
        this.#menuDialog?.addEventListener('close', this.#syncMenuState);
        this.#stackedSearchInput?.addEventListener(
          'focus',
          this.#handleStackedSearchFocus,
        );
        this.#stackedSearchInput?.addEventListener(
          'blur',
          this.#handleStackedSearchBlur,
        );
        this.addEventListener(
          'header:mobile-search-ready',
          this.#handleSearchReady,
        );
        this.addEventListener(
          'header:mobile-search-unready',
          this.#handleSearchUnready,
        );
        document.addEventListener('keydown', this.#handleDocumentKeydown);
        document.addEventListener('click', this.#handleDocumentClick);
        this.#mediaQuery.addEventListener('change', this.#handleMediaChange);
        this.#icons?.addEventListener(
          'transitionend',
          this.#handleIconsTransitionEnd,
        );
        this.#icons?.addEventListener(
          'transitioncancel',
          this.#handleIconsTransitionEnd,
        );

        if (typeof ResizeObserver === 'function' && this.#inner) {
          this.#resizeObserver = new ResizeObserver(this.#scheduleLayoutSync);
          this.#resizeObserver.observe(this.#inner);
          this.#resizeObserver.observe(this.#start);
          if (this.#nav) {
            this.#resizeObserver.observe(this.#nav);
          }
          if (this.#end) {
            this.#resizeObserver.observe(this.#end);
          }
          // Do not observe the desktop search itself: show/hide and min-width
          // updates are outputs of layout sync and would feedback-loop.
          if (this.#icons) {
            this.#resizeObserver.observe(this.#icons);
          }
        } else {
          window.addEventListener('resize', this.#scheduleLayoutSync);
        }

        if (document.fonts?.ready) {
          document.fonts.ready.then(() => this.#scheduleLayoutSync());
        }

        this.#watchStickyOffset();
        this.#scheduleLayoutSync();
      }

      disconnectedCallback() {
        this.#menuToggle?.removeEventListener('click', this.#toggleMenu);
        this.#menuDialog?.removeEventListener('click', this.#handleDialogClick);
        this.#menuDialog?.removeEventListener('close', this.#syncMenuState);
        this.#stackedSearchInput?.removeEventListener(
          'focus',
          this.#handleStackedSearchFocus,
        );
        this.#stackedSearchInput?.removeEventListener(
          'blur',
          this.#handleStackedSearchBlur,
        );
        this.removeEventListener(
          'header:mobile-search-ready',
          this.#handleSearchReady,
        );
        this.removeEventListener(
          'header:mobile-search-unready',
          this.#handleSearchUnready,
        );
        document.removeEventListener('keydown', this.#handleDocumentKeydown);
        document.removeEventListener('click', this.#handleDocumentClick);
        this.#mediaQuery?.removeEventListener(
          'change',
          this.#handleMediaChange,
        );
        this.#icons?.removeEventListener(
          'transitionend',
          this.#handleIconsTransitionEnd,
        );
        this.#icons?.removeEventListener(
          'transitioncancel',
          this.#handleIconsTransitionEnd,
        );
        this.#resizeObserver?.disconnect();
        this.#stickyObserver?.disconnect();
        this.#stickyObserver = null;
        document.documentElement.style.removeProperty('--sticky-header-offset');
        window.removeEventListener('resize', this.#scheduleLayoutSync);
        this.#clearMenuCloseTimer();
        this.#clearMenuOpenTimer();
        this.#setMobileNavigationInert(false);
        this.#setBackgroundInert(false);
        this.#setDocumentScrollLock('header-menu-open', false);

        if (this.#frameId) {
          window.cancelAnimationFrame(this.#frameId);
        }
      }

      #toggleMenu = () => {
        if (!this.#menuDialog) return;

        // Reversing mid-close keeps the menu open and restores the X toggle.
        if (this.#isMenuClosing) {
          this.#cancelMenuClose();
          return;
        }

        if (this.#menuDialog.open) {
          // Search panel owns dismiss only after it marks ready; focusing the
          // stacked input alone must not add an invisible extra close step.
          if (this.#isInMenuSearch()) {
            this.#exitMenuSearch();
            return;
          }

          this.#closeMenu();
          return;
        }

        this.#openMenu();
      };

      #openMenu() {
        if (!this.#menuDialog || this.#menuDialog.open) {
          return;
        }

        this.#syncMobileMenuTop();
        this.#menuDialog.classList.remove('is-closing');
        this.#menuDialog.classList.remove('is-open-animating');
        this.#clearMenuOpenTimer();

        // Hold the panel off-screen for one frame so open always animates from
        // under the header instead of popping in (dialog show() can skip
        // @starting-style in some browsers).
        if (!this.#prefersReducedMotion()) {
          this.#menuDialog.classList.add('is-opening');
        }

        // Non-modal: keeps header close control and stacked search interactive.
        this.#menuDialog.show();
        this.#syncMenuState();

        if (!this.#menuDialog.classList.contains('is-opening')) return;

        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            if (!this.#menuDialog?.open) return;

            this.#menuDialog.classList.remove('is-opening');
            // Keep dismiss disabled while the panel finishes sliding in —
            // is-opening only covers the pre-paint hold, not the 280ms transition.
            this.#menuDialog.classList.add('is-open-animating');
            this.#clearMenuOpenTimer();
            this.#menuOpenTimer = window.setTimeout(() => {
              this.#menuOpenTimer = 0;
              this.#menuDialog?.classList.remove('is-open-animating');
            }, RokaHeader.MENU_CLOSE_MS);
          });
        });
      }

      #closeMenu() {
        if (!this.#menuDialog?.open || this.#isMenuClosing) return;

        this.#menuDialog.classList.remove('is-opening');
        this.#menuDialog.classList.remove('is-open-animating');
        this.#clearMenuOpenTimer();
        // Collapse localization before the slide-up so a teleported panel does
        // not float over the transparent dialog for the close duration.
        this.#closeMenuLocalization();

        if (this.#prefersReducedMotion()) {
          this.#menuDialog.close();
          return;
        }

        this.#isMenuClosing = true;
        this.#menuDialog.classList.add('is-closing');
        this.#clearMenuCloseTimer();

        this.#menuCloseTimer = window.setTimeout(() => {
          this.#menuCloseTimer = 0;
          // Keep is-closing until the close event so open CSS cannot snap the
          // panel back to translateY(0) for a frame. #syncMenuState clears it.
          this.#menuDialog?.close();
        }, RokaHeader.MENU_CLOSE_MS);
      }

      #closeMenuLocalization() {
        if (!this.#menuDialog) return;

        for (const details of this.#menuDialog.querySelectorAll(
          '.footer-localization__disclosure[open]',
        )) {
          details.open = false;
        }
      }

      #cancelMenuClose() {
        if (!this.#isMenuClosing) return;

        this.#clearMenuCloseTimer();
        this.#isMenuClosing = false;
        this.#menuDialog?.classList.remove('is-closing');
        this.#syncMenuState();
      }

      #handleDialogClick = (event) => {
        if (event.target === this.#menuDialog) {
          this.#closeMenu();
        }
      };

      #handleDocumentKeydown = (event) => {
        if (event.key !== 'Escape' || !this.#menuDialog?.open) return;

        if (this.#isInMenuSearch()) {
          this.#exitMenuSearch();
          return;
        }

        this.#closeMenu();
      };

      #handleDocumentClick = (event) => {
        if (!this.#menuDialog?.open) return;

        // Opening cart (or other excluded overlays) from the header while the
        // non-modal menu is open must clear inert before the overlay is used.
        if (!event.target.closest('[data-cart-drawer-open]')) return;

        this.#closeMenu();
      };

      #handleStackedSearchFocus = () => {
        if (!this.#menuDialog?.open) return;

        this.classList.add('header--menu-search-active');
        this.dispatchEvent(
          new CustomEvent('header:mobile-search-open', {
            bubbles: true,
            detail: { panel: this.#menuSearchPanel },
          }),
        );
      };

      #handleStackedSearchBlur = () => {
        // Pending open (active, not ready) drops when focus leaves — no search
        // UI claimed the panel. Once ready, keep mode until burger/Escape so
        // focus can move into the search panel without flashing the nav back.
        if (!this.classList.contains('header--menu-search-ready')) {
          this.classList.remove('header--menu-search-active');
        }
      };

      #handleSearchReady = () => {
        // Ignore late ready after blur/close cleared search or closed the menu,
        // otherwise nav stays inert and the next burger tap exits a ghost search.
        if (!this.#menuDialog?.open) return;
        if (!this.classList.contains('header--menu-search-active')) return;

        // Collapse localization before the nav fades/goes inert — the panel is
        // teleported onto the dialog and would otherwise stay interactive.
        this.#closeMenuLocalization();
        this.classList.add('header--menu-search-ready');
        this.#menuSearchPanel?.removeAttribute('hidden');
        this.#setMobileNavigationInert(true);
      };

      #handleSearchUnready = () => {
        this.classList.remove('header--menu-search-ready');
        this.#menuSearchPanel?.setAttribute('hidden', '');
        this.#setMobileNavigationInert(false);
      };

      #exitMenuSearch() {
        const wasInSearch = this.#isInMenuSearch();

        this.classList.remove('header--menu-search-active');
        this.classList.remove('header--menu-search-ready');
        this.#menuSearchPanel?.setAttribute('hidden', '');
        this.#setMobileNavigationInert(false);
        this.#stackedSearchInput?.blur();
        this.dispatchEvent(
          new CustomEvent('header:mobile-search-close', {
            bubbles: true,
            detail: { panel: this.#menuSearchPanel },
          }),
        );

        // Escape (and burger) leave the menu open; keep keyboard focus on the
        // toggle so users are not stranded on document.body.
        if (wasInSearch) {
          this.#menuToggle?.focus();
        }
      }

      #isInMenuSearch() {
        return this.classList.contains('header--menu-search-ready');
      }

      #syncMenuState = () => {
        if (!this.#menuToggle || !this.#menuDialog) return;

        const isOpen = this.#menuDialog.open;
        this.#menuToggle.setAttribute('aria-expanded', String(isOpen));
        this.#setDocumentScrollLock('header-menu-open', isOpen);
        this.#setBackgroundInert(isOpen);

        if (isOpen) {
          // Clear stale inert if search never became ready (or a late ready was ignored).
          if (!this.#isInMenuSearch()) {
            this.#setMobileNavigationInert(false);
          }
          return;
        }

        this.#isMenuClosing = false;
        this.#menuDialog.classList.remove('is-closing');
        this.#menuDialog.classList.remove('is-opening');
        this.#menuDialog.classList.remove('is-open-animating');
        this.#clearMenuCloseTimer();
        this.#clearMenuOpenTimer();
        this.#exitMenuSearch();

        // Non-modal dialogs do not restore focus; return it to the toggle when
        // focus was inside the menu or already lost to the document.
        const active = document.activeElement;
        const focusWasInMenu =
          !(active instanceof HTMLElement) ||
          active === document.body ||
          this.#menuDialog.contains(active);

        if (focusWasInMenu) {
          this.#menuToggle.focus();
        }
      };

      #setDocumentScrollLock(lockClass, locked) {
        const root = document.documentElement;
        const lockClasses = ['header-menu-open', 'header-mega-menu-open'];

        if (locked) {
          const alreadyLocked = lockClasses.some((name) =>
            root.classList.contains(name),
          );

          if (!alreadyLocked) {
            const compensation = Math.max(
              0,
              window.innerWidth - root.clientWidth,
            );
            root.style.setProperty(
              '--scrollbar-compensation',
              `${compensation}px`,
            );
          }

          root.classList.add(lockClass);
          return;
        }

        root.classList.remove(lockClass);

        const stillLocked = lockClasses.some((name) =>
          root.classList.contains(name),
        );

        if (!stillLocked) {
          root.style.removeProperty('--scrollbar-compensation');
        }
      }

      #prefersReducedMotion() {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      }

      #clearMenuCloseTimer() {
        if (!this.#menuCloseTimer) return;

        window.clearTimeout(this.#menuCloseTimer);
        this.#menuCloseTimer = 0;
      }

      #clearMenuOpenTimer() {
        if (!this.#menuOpenTimer) return;

        window.clearTimeout(this.#menuOpenTimer);
        this.#menuOpenTimer = 0;
      }

      #setBackgroundInert(isInert) {
        const headerGroup =
          this.closest('.shopify-section-group-header-group') || this;

        for (const child of document.body.children) {
          if (!(child instanceof HTMLElement)) continue;
          if (child === headerGroup || headerGroup.contains(child)) continue;
          if (child.contains(this)) continue;
          // Keep cart drawer / other overlays usable if they sit outside the
          // header group (or are relocated as body-level hosts).
          if (this.#isOverlayHost(child)) {
            child.removeAttribute('inert');
            continue;
          }

          child.toggleAttribute('inert', isInert);
        }
      }

      #setMobileNavigationInert(isInert) {
        this.#mobileNavigation?.toggleAttribute('inert', isInert);
      }

      #isOverlayHost(element) {
        return Boolean(
          element.matches?.('cart-drawer, [data-header-menu-inert-exclude]') ||
          element.querySelector(
            'cart-drawer, [data-cart-drawer-dialog], [data-header-menu-inert-exclude]',
          ),
        );
      }

      // The ResizeObserver below watches both the field and the icon cluster,
      // so every frame of the search collapse resizes something it is
      // listening to. Syncing on each of those runs the layout probe against a
      // header that is mid-transition; the drawer flags the animation instead
      // and `#handleIconsTransitionEnd` runs the one sync that was owed.
      // Defer rather than drop. A cancelled transition fires `transitioncancel`
      // and a breakpoint change removes the declarations entirely, so a sync
      // discarded here could otherwise never be recovered and every observer
      // callback in the window would be lost.
      #scheduleLayoutSync = () => {
        if (
          this.#mediaQuery?.matches &&
          this.#header?.classList.contains('header--search-animating')
        ) {
          this.#pendingLayoutSync = true;
          return;
        }

        this.#queueLayoutSync();
      };

      #flushPendingLayoutSync = () => {
        if (!this.#pendingLayoutSync) return;

        this.#pendingLayoutSync = false;
        this.#queueLayoutSync();
      };

      // A breakpoint change has to resolve even mid-collapse: below 768px
      // nothing animates, so no `transitionend` would arrive to release it.
      #handleMediaChange = () => {
        this.#queueLayoutSync();
      };

      // `opacity` finishes at 60% of the collapse, so releasing on the first
      // property to end would run a sync — and with it `#withoutMotion` — into
      // the middle of the animation, cancelling the width and gap transitions
      // and snapping them to their end values. `max-width` is the property that
      // defines the collapse, so its completion is the only point at which the
      // header geometry is final. `transitioncancel` counts as an ending too:
      // a breakpoint change drops the declarations outright, and without it the
      // owed sync would never be flushed.
      // `opacity` finishes at 60% of the motion, so releasing on the first
      // property to end would run a sync — and with it `#withoutMotion` —
      // into the middle of it. `transform` runs the full duration alongside
      // the field's own growth, so its ending is the point at which the
      // header's geometry is final. `transitioncancel` counts as an ending
      // too: a breakpoint change drops the declarations outright, and without
      // it the owed sync would never be flushed.
      #handleIconsTransitionEnd = (event) => {
        if (event.target !== this.#icons) return;
        if (event.propertyName !== 'transform') return;

        this.#pendingLayoutSync = false;
        this.#queueLayoutSync();
      };

      #queueLayoutSync() {
        if (this.#frameId) {
          window.cancelAnimationFrame(this.#frameId);
        }

        this.#frameId = window.requestAnimationFrame(() => {
          this.#frameId = 0;
          this.#syncNavLayout();
          this.#syncMobileMenuTop();
        });
      }

      // Anything else on the page that sticks to the top of the viewport — the
      // collection filter bar, the doorway overlays — has to clear the header
      // when the merchant has it sticky, and land at 0 when they don't. The
      // height can't be hardcoded on the other end: it is 60px, 88px above
      // 768px, and 60px again for the compact and stacked layouts, and
      // --header-height is scoped to .header so it doesn't inherit out of this
      // section. Publish the measured height on the root instead, always set,
      // so a component can read it unconditionally.
      #watchStickyOffset() {
        if (!this.classList.contains('header-wrapper--sticky')) {
          this.#publishStickyOffset(0);
          return;
        }

        this.#publishStickyOffset(this.offsetHeight);

        if (typeof ResizeObserver !== 'function') return;

        this.#stickyObserver = new ResizeObserver(() =>
          this.#publishStickyOffset(this.offsetHeight),
        );
        this.#stickyObserver.observe(this);
      }

      #publishStickyOffset(height) {
        document.documentElement.style.setProperty(
          '--sticky-header-offset',
          `${height}px`,
        );
      }

      #syncMobileMenuTop() {
        if (!this.#header || !this.#menuDialog) return;

        const top = Math.max(0, this.#header.getBoundingClientRect().bottom);
        this.#menuDialog.style.setProperty(
          '--header-mobile-menu-top',
          `${top}px`,
        );
      }

      #syncNavLayout() {
        if (!this.#header || !this.#inner || !this.#start) return;

        this.#withoutMotion(() => {
          if (this.#mediaQuery?.matches) {
            this.#applyLayout(
              this.#withSearchOpenProbe(() => this.#resolveDesktopLayout()),
            );
          } else {
            this.#applyLayout('mobile');
          }

          this.#syncIconsWidth();
        });
      }

      // Every probe below removes a state class, forces a reflow and puts it
      // back. Now that the search cluster interpolates, each of those flips
      // would start a transition towards a state the header was never in and
      // then reverse it — several times a second. Motion is suppressed for the
      // whole sync, and the restored geometry is flushed before it is allowed
      // back, so lifting the guard cannot animate anything either.
      #withoutMotion(callback) {
        const header = this.#header;

        if (!header) return callback();

        header.classList.add('header--no-motion');

        try {
          return callback();
        } finally {
          void header.offsetWidth;
          header.classList.remove('header--no-motion');
        }
      }

      // The open search drawer collapses the icon cluster and lets the field
      // grow. Resolve against the resting header instead, so opening search
      // cannot flip layout mode — and so a resize while it is open still
      // resolves. Always called from inside `#withoutMotion`.
      #withSearchOpenProbe(callback) {
        const header = this.#header;

        if (!header?.classList.contains('header--search-open')) {
          return callback();
        }

        header.classList.remove('header--search-open');
        void header.offsetWidth;

        const result = callback();

        header.classList.add('header--search-open');

        return result;
      }

      // The collapse needs a length at both ends to interpolate from, and the
      // resting width is the only authoritative one. Measured inside the
      // resting probe (the open cluster is 0 wide) and after the layout mode
      // is final, since compact and inline carry different cluster gaps.
      #syncIconsWidth() {
        if (!this.#icons || !this.#header) return;

        this.#withSearchOpenProbe(() => {
          const width = this.#icons.getBoundingClientRect().width;

          if (width > 0) {
            this.#header.style.setProperty(
              '--header-icons-width',
              `${width}px`,
            );
          }

          // The open width builds on this measurement, so it has to be the
          // true resting box. The clear button is drawer-owned and stays
          // visible while a query is typed, which would read ~24px wide.
          const field = this.#header.querySelector('.header__search--desktop');
          if (!field) return;

          const clear = field.querySelector('[data-header-search-clear]');
          const clearWasVisible = clear ? !clear.hidden : false;

          if (clearWasVisible) clear.hidden = true;

          try {
            // The resting min-width reads this same property, so measuring
            // with it in place could only ever ratchet upward. Lift it, let
            // the field settle on its natural width, then record that.
            this.#header.style.removeProperty('--header-search-rest');

            const restWidth = field.getBoundingClientRect().width;

            if (restWidth > 0) {
              this.#header.style.setProperty(
                '--header-search-rest',
                `${restWidth}px`,
              );
            }
          } finally {
            if (clearWasVisible) clear.hidden = false;
          }
        });
      }

      #resolveDesktopLayout() {
        const current = this.#getCurrentDesktopMode();
        const measurements = this.#getMeasurements();
        const innerWidth = this.#inner.clientWidth;

        if (current === 'compact') {
          if (
            measurements.stackedTopRowNeeded + RokaHeader.COMPACT_EXPAND_SLACK >
            innerWidth
          ) {
            return 'compact';
          }

          if (
            measurements.inlineNeeded + RokaHeader.INLINE_EXPAND_SLACK <=
              innerWidth &&
            this.#withInlineLayoutProbe(() => this.#hasComfortableInlineSpace())
          ) {
            return 'inline';
          }

          return 'stacked';
        }

        if (current === 'stacked') {
          if (
            measurements.stackedTopRowNeeded +
              RokaHeader.COMPACT_COLLAPSE_SLACK >
              innerWidth ||
            this.#hasTopRowCollision()
          ) {
            return 'compact';
          }

          if (
            measurements.inlineNeeded + RokaHeader.INLINE_EXPAND_SLACK <=
              innerWidth &&
            this.#withInlineLayoutProbe(() => this.#hasComfortableInlineSpace())
          ) {
            return 'inline';
          }

          return 'stacked';
        }

        if (
          measurements.inlineNeeded + RokaHeader.INLINE_COLLAPSE_SLACK >
            innerWidth ||
          this.#hasInlineClusterCollision()
        ) {
          return 'stacked';
        }

        return 'inline';
      }

      #getCurrentDesktopMode() {
        if (
          this.#layoutMode === 'compact' ||
          this.#layoutMode === 'stacked' ||
          this.#layoutMode === 'inline'
        ) {
          return this.#layoutMode;
        }

        if (this.#header?.classList.contains('header--compact')) {
          return 'compact';
        }

        if (this.#header?.classList.contains('header--search-stacked')) {
          return 'stacked';
        }

        return 'inline';
      }

      #getMeasurements() {
        return this.#withExpandedMeasurements(() => {
          const innerGap = this.#getInnerGap();
          const endGap = this.#getEndGap();
          const startWidth = this.#getStartScrollWidth();
          const iconsWidth = this.#icons?.offsetWidth ?? 0;
          const searchWidth = this.#getDesktopSearchWidth();
          const clusterGap = RokaHeader.CLUSTER_MIN_GAP;

          return {
            inlineNeeded:
              startWidth +
              innerGap +
              clusterGap +
              searchWidth +
              endGap +
              iconsWidth,
            stackedTopRowNeeded:
              startWidth + innerGap + clusterGap + iconsWidth,
          };
        });
      }

      #getDesktopSearchWidth() {
        const search = this.#desktopSearch;

        if (!search) return RokaHeader.SEARCH_MIN_WIDTH;

        // Prefer the animated-text min width so hidden vs visible search does
        // not flip between SEARCH_MIN_WIDTH and the grown field size (that
        // asymmetry causes inline ↔ stacked thrashing near the breakpoint).
        const cssMin =
          Number.parseFloat(
            search.style.getPropertyValue('--header-search-min-width'),
          ) ||
          Number.parseFloat(
            getComputedStyle(search).getPropertyValue(
              '--header-search-min-width',
            ),
          ) ||
          0;
        const measuredWidth = search.offsetWidth;

        if (measuredWidth > 0) {
          return Math.max(measuredWidth, cssMin, RokaHeader.SEARCH_MIN_WIDTH);
        }

        return Math.max(cssMin, RokaHeader.SEARCH_MIN_WIDTH);
      }

      #hasInlineClusterCollision() {
        if (
          !this.#desktopSearch ||
          this.#desktopSearch.hasAttribute('hidden')
        ) {
          return false;
        }

        return (
          this.#hasNavOverflow() || this.#getClusterGap(this.#desktopSearch) < 1
        );
      }

      #hasComfortableInlineSpace() {
        if (
          !this.#desktopSearch ||
          this.#desktopSearch.hasAttribute('hidden')
        ) {
          return false;
        }

        return (
          !this.#hasNavOverflow() &&
          this.#getClusterGap(this.#desktopSearch) >= RokaHeader.CLUSTER_MIN_GAP
        );
      }

      #hasTopRowCollision() {
        if (!this.#icons) return false;

        return this.#hasNavOverflow() || this.#getClusterGap(this.#icons) < 1;
      }

      #hasNavOverflow() {
        if (!this.#nav) return false;

        return this.#nav.scrollWidth > this.#nav.clientWidth + 1;
      }

      #getClusterGap(target) {
        return (
          target.getBoundingClientRect().left - this.#getStartContentRight()
        );
      }

      #getStartContentRight() {
        let right = this.#start?.getBoundingClientRect().left ?? 0;

        if (!this.#start) return right;

        for (const child of this.#start.children) {
          const rect = child.getBoundingClientRect();

          if (rect.width > 0) {
            right = Math.max(right, rect.right);
          }
        }

        return right;
      }

      #withInlineLayoutProbe(callback) {
        const header = this.#header;

        if (!header) return callback();

        const restore = {
          compact: header.classList.contains('header--compact'),
          stacked: header.classList.contains('header--search-stacked'),
          hideDesktopSearch:
            this.#desktopSearch?.hasAttribute('hidden') ?? false,
          hideStackedSearch:
            this.#stackedSearch?.hasAttribute('hidden') ?? false,
        };

        if (
          !restore.compact &&
          !restore.stacked &&
          !restore.hideDesktopSearch
        ) {
          return callback();
        }

        header.classList.remove('header--compact', 'header--search-stacked');
        this.#desktopSearch?.removeAttribute('hidden');
        this.#stackedSearch?.setAttribute('hidden', '');
        void header.offsetWidth;

        const result = callback();

        if (restore.hideDesktopSearch) {
          this.#desktopSearch?.setAttribute('hidden', '');
        } else {
          this.#desktopSearch?.removeAttribute('hidden');
        }

        if (restore.hideStackedSearch) {
          this.#stackedSearch?.setAttribute('hidden', '');
        } else {
          this.#stackedSearch?.removeAttribute('hidden');
        }

        if (restore.stacked) {
          header.classList.add('header--search-stacked');
        }

        if (restore.compact) {
          header.classList.add('header--compact');
        }

        return result;
      }

      #withExpandedMeasurements(callback) {
        const header = this.#header;

        if (!header?.classList.contains('header--compact')) {
          return callback();
        }

        const restore = {
          compact: true,
          stacked: header.classList.contains('header--search-stacked'),
          hideDesktopSearch:
            this.#desktopSearch?.hasAttribute('hidden') ?? false,
        };

        header.classList.remove('header--compact', 'header--search-stacked');
        this.#desktopSearch?.removeAttribute('hidden');
        void header.offsetWidth;

        const result = callback();

        if (restore.hideDesktopSearch) {
          this.#desktopSearch?.setAttribute('hidden', '');
        }

        if (restore.stacked) {
          header.classList.add('header--search-stacked');
        }

        header.classList.add('header--compact');

        return result;
      }

      #getStartScrollWidth() {
        const children = [...this.#start.children].filter(
          (child) => child.scrollWidth > 0,
        );

        if (children.length === 0) return 0;

        const gap =
          Number.parseFloat(getComputedStyle(this.#start).columnGap) ||
          Number.parseFloat(getComputedStyle(this.#start).gap) ||
          0;

        const childrenWidth = children.reduce(
          (total, child) => total + child.scrollWidth,
          0,
        );

        return childrenWidth + gap * (children.length - 1);
      }

      #getInnerGap() {
        return (
          Number.parseFloat(getComputedStyle(this.#inner).columnGap) ||
          Number.parseFloat(getComputedStyle(this.#inner).gap) ||
          0
        );
      }

      #getEndGap() {
        if (!this.#end) return 0;

        return (
          Number.parseFloat(getComputedStyle(this.#end).columnGap) ||
          Number.parseFloat(getComputedStyle(this.#end).gap) ||
          0
        );
      }

      #applyLayout(mode) {
        if (this.#layoutMode === mode) return;

        const isDesktop = Boolean(this.#mediaQuery?.matches);
        const isCompact = isDesktop && mode === 'compact';
        const isStacked = isDesktop && mode === 'stacked';

        this.#header?.classList.toggle('header--compact', isCompact);
        this.#header?.classList.toggle('header--search-stacked', isStacked);

        if (!isDesktop) {
          this.#header?.classList.remove(
            'header--compact',
            'header--search-stacked',
          );
          this.#desktopSearch?.setAttribute('hidden', '');
          this.#stackedSearch?.removeAttribute('hidden');
          this.#layoutMode = mode;
          return;
        }

        if (mode === 'inline') {
          this.#desktopSearch?.removeAttribute('hidden');
          this.#stackedSearch?.setAttribute('hidden', '');
        } else {
          this.#desktopSearch?.setAttribute('hidden', '');
          this.#stackedSearch?.removeAttribute('hidden');
        }

        if (isCompact) {
          this.#closeMegaMenu();
        }

        if (!isCompact && this.#menuDialog?.open) {
          this.#menuDialog.close();
        }

        this.#layoutMode = mode;
      }

      #closeMegaMenu() {
        const megaMenu = this.querySelector('header-mega-menu');

        if (typeof megaMenu?.close === 'function') {
          megaMenu.close(false);
        }
      }
    }

    customElements.define(COMPONENT_NAME, RokaHeader);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    /* global Shopify */
    const FORM_NAME = 'product-form';

    const formatMoney = (cents, format) => {
      const formatString =
        format ||
        window.theme?.moneyFormat ||
        (typeof Shopify !== 'undefined' ? Shopify.money_format : null) ||
        '$' +
          String.fromCharCode(123, 123) +
          'amount' +
          String.fromCharCode(125, 125);
      const placeholder = /\{\{\s*(\w+)\s*\}\}/;
      const match = formatString.match(placeholder);

      if (!match) {
        if (
          typeof Shopify !== 'undefined' &&
          typeof Shopify.formatMoney === 'function'
        ) {
          return Shopify.formatMoney(cents, formatString);
        }

        return (Number(cents) / 100).toFixed(2);
      }

      const value = Number(cents) || 0;
      let amount = '';

      switch (match[1]) {
        case 'amount_no_decimals':
          amount = (value / 100).toFixed(0);
          break;
        case 'amount_with_comma_separator':
          amount = (value / 100)
            .toFixed(2)
            .replace('.', ',')
            .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
          break;
        case 'amount_no_decimals_with_comma_separator':
          amount = (value / 100)
            .toFixed(0)
            .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
          break;
        case 'amount_with_apostrophe_separator':
          amount = (value / 100)
            .toFixed(2)
            .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1'");
          break;
        default:
          amount = (value / 100)
            .toFixed(2)
            .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
      }

      return formatString.replace(placeholder, amount);
    };

    class ProductForm extends HTMLElement {
      #product = null;
      #variantInput = null;
      #optionInputs = [];
      #quantityInput = null;
      #priceNode = null;
      #comparePriceNode = null;
      #addToCartButton = null;
      #notifyButton = null;
      #quantityWrapper = null;
      #stockMessage = null;
      #preorderProperty = null;
      #preorderFlag = null;
      #inventory = {};

      connectedCallback() {
        const jsonNode = this.querySelector('[data-product-json]');
        if (!jsonNode) return;

        try {
          this.#product = JSON.parse(jsonNode.textContent);
        } catch {
          return;
        }

        const formId = this.dataset.productFormId;
        this.#variantInput = document.querySelector(
          `#${formId} [data-variant-input]`,
        );
        this.#optionInputs = [...this.querySelectorAll('[data-option-input]')];
        this.#quantityInput = this.querySelector('[data-quantity-input]');
        this.#priceNode = this.querySelector('[data-price-current]');
        this.#comparePriceNode = this.querySelector('.card-price__compare');
        this.#addToCartButton = this.querySelector('[data-add-to-cart]');
        this.#notifyButton = this.querySelector('[data-notify-trigger]');
        this.#quantityWrapper = this.querySelector('[data-quantity-wrapper]');
        this.#stockMessage = this.querySelector('[data-stock-message]');
        this.#preorderProperty = this.querySelector('[data-preorder-property]');
        this.#preorderFlag = this.querySelector('[data-preorder-flag]');

        // Storefront product JSON has no inventory_quantity, so stock levels
        // come from the map the buy buttons render next to the form.
        const inventoryNode = this.querySelector('[data-variant-inventory]');

        if (inventoryNode) {
          try {
            this.#inventory = JSON.parse(inventoryNode.textContent) || {};
          } catch {
            this.#inventory = {};
          }
        }

        for (const input of this.#optionInputs) {
          input.addEventListener('change', () => this.#onOptionChange());
        }

        const minusButton = this.querySelector('[data-quantity-minus]');
        const plusButton = this.querySelector('[data-quantity-plus]');

        minusButton?.addEventListener('click', () => this.#updateQuantity(-1));
        plusButton?.addEventListener('click', () => this.#updateQuantity(1));

        this.#updateSizeUi();
        this.#updateOptionAvailability();
      }

      #onOptionChange() {
        const selectedOptions = this.#getSelectedOptions();
        const variant = this.#findVariant(selectedOptions);

        if (!variant) return;

        if (this.#variantInput) {
          this.#variantInput.value = variant.id;
        }

        for (const paymentInput of document.querySelectorAll(
          '[data-payment-variant-input]',
        )) {
          paymentInput.value = variant.id;
        }

        this.#updatePrice(variant);
        this.#updateAvailability(variant);
        this.#updateUrl(variant);
        this.#updateSizeUi();
        this.#updateOptionAvailability();

        this.dispatchEvent(
          new CustomEvent('variant:change', {
            bubbles: true,
            detail: { variant, product: this.#product },
          }),
        );
      }

      #updateSizeUi() {
        const sizeInput = this.#optionInputs.find(
          (input) => input.matches('[data-size-input]') && input.checked,
        );
        const sizeLabel = this.querySelector('[data-size-label-value]');

        if (sizeInput && sizeLabel) {
          sizeLabel.textContent = sizeInput.value;
        }
      }

      // Whether a value can be bought depends on the other groups' current
      // selection, so every tile is re-tested against the live selection with
      // its own value swapped in. Liquid renders the same state for first
      // paint; this keeps it true as the shopper changes their mind.
      #updateOptionAvailability() {
        const variants = this.#product?.variants;

        if (!Array.isArray(variants) || variants.length === 0) return;

        const selected = this.#getSelectedOptions();
        const unavailableText = this.dataset.unavailableText || '';

        for (const input of this.#optionInputs) {
          const position = Number(input.dataset.optionPosition);
          const tile = input.closest(
            '.product-variant-picker__size, .product-variant-picker__option',
          );

          if (!position || !tile) continue;

          const candidate = [...selected];
          candidate[position - 1] = input.value;

          const available = variants.some(
            (variant) =>
              variant.available &&
              variant.options.every((option, index) => {
                const wanted = candidate[index];

                // A position the picker does not control (Colour lives on
                // separate products) constrains nothing.
                if (wanted == null || wanted === '') return true;

                return option === wanted;
              }),
          );

          tile.toggleAttribute('data-unavailable', !available);

          let note = tile.querySelector('[data-unavailable-text]');

          if (!available && !note && unavailableText) {
            note = document.createElement('span');
            note.className = 'visually-hidden';
            note.setAttribute('data-unavailable-text', '');
            note.textContent = unavailableText;
            tile.append(note);
          } else if (available && note) {
            note.remove();
          }
        }
      }

      #getSelectedOptions() {
        const options = [];

        for (const input of this.#optionInputs) {
          if (!input.checked) continue;

          const position = Number(input.dataset.optionPosition);
          options[position - 1] = input.value;
        }

        return options;
      }

      #findVariant(selectedOptions) {
        const variants = this.#product?.variants;

        if (!Array.isArray(variants) || variants.length === 0) return null;

        const currentId = this.#variantInput
          ? Number(this.#variantInput.value)
          : null;
        const currentVariant =
          variants.find((v) => Number(v.id) === currentId) ||
          variants.find((v) => v.available) ||
          variants[0];

        if (!currentVariant?.options) return null;

        // Fill option positions the picker does not control (e.g. Colour when
        // colourways are separate Hallway products) from the current variant
        // instead of matching any value at that index.
        const resolvedOptions = currentVariant.options.map((option, index) => {
          const selected = selectedOptions[index];

          if (selected == null || selected === '') return option;

          return selected;
        });

        return variants.find((variant) =>
          variant.options.every(
            (option, index) => option === resolvedOptions[index],
          ),
        );
      }

      #updatePrice(variant) {
        if (!this.#priceNode) return;

        const defaultMoneyFormat =
          '$' +
          String.fromCharCode(123, 123) +
          'amount' +
          String.fromCharCode(125, 125);
        const moneyFormat =
          window.theme?.moneyFormat ||
          (typeof Shopify !== 'undefined'
            ? Shopify.money_format
            : defaultMoneyFormat);

        this.#priceNode.textContent = formatMoney(variant.price, moneyFormat);

        if (this.#comparePriceNode) {
          if (variant.compare_at_price > variant.price) {
            this.#comparePriceNode.innerHTML = `<s>${formatMoney(variant.compare_at_price, moneyFormat)}</s>`;
            this.#comparePriceNode.hidden = false;
          } else {
            this.#comparePriceNode.hidden = true;
          }
        }
      }

      #updateAvailability(variant) {
        const lowStockThreshold = Number(
          this.#stockMessage?.dataset.lowStockThreshold ?? 10,
        );
        const stock = this.#inventory[String(variant.id)];
        const tracked = stock?.t === true;
        const quantity = Number(stock?.q ?? 0);
        const showNotify = !variant.available && this.#notifyButton != null;
        // Pre-order rides on oversell, so the variant reads as available and
        // only the map knows the difference.
        const isPreorder = stock?.p === true && variant.available;
        const preorderMessage = String(stock?.m || '');

        if (this.#notifyButton) {
          this.#notifyButton.hidden = !showNotify;
          this.#notifyButton.dataset.variantId = String(variant.id);
        }

        this.#quantityWrapper?.classList.toggle(
          'product-buy-buttons__quantity--hidden',
          !variant.available,
        );

        if (this.#addToCartButton) {
          const { dataset } = this.#addToCartButton;
          let label = dataset.soldOutLabel || 'Out of Stock';

          if (isPreorder) {
            label = dataset.preorderLabel || 'Pre-order';
          } else if (variant.available) {
            label = dataset.availableLabel || 'Add to bag';
          }

          this.#addToCartButton.hidden = showNotify;
          this.#addToCartButton.disabled = !variant.available;
          this.#addToCartButton.textContent = label;
          dataset.preorderActive = String(isPreorder);
          this.#addToCartButton.classList.toggle(
            'product-buy-buttons__submit--oos',
            !variant.available,
          );
        }

        if (this.#preorderProperty) {
          this.#preorderProperty.value = preorderMessage;
          this.#preorderProperty.disabled = !isPreorder;
        }

        if (this.#preorderFlag) {
          this.#preorderFlag.disabled = !isPreorder;
        }

        if (!this.#stockMessage) return;

        this.#stockMessage.classList.toggle(
          'product-buy-buttons__stock--preorder',
          isPreorder,
        );

        const showLowStock =
          variant.available &&
          tracked &&
          quantity > 0 &&
          quantity <= lowStockThreshold;

        if (!variant.available) {
          this.#stockMessage.textContent =
            this.#stockMessage.dataset.outOfStockLabel || 'Out of Stock';
          this.#stockMessage.classList.remove(
            'product-buy-buttons__stock--hidden',
          );
        } else if (isPreorder) {
          this.#stockMessage.textContent = preorderMessage;
          this.#stockMessage.classList.remove(
            'product-buy-buttons__stock--hidden',
          );
        } else if (showLowStock) {
          const template =
            this.#stockMessage.dataset.lowStockTemplate ||
            'Only {count} left in stock';
          this.#stockMessage.textContent = template.replace(
            '{count}',
            String(quantity),
          );
          this.#stockMessage.classList.remove(
            'product-buy-buttons__stock--hidden',
          );
        } else {
          this.#stockMessage.textContent = '';
          this.#stockMessage.classList.add(
            'product-buy-buttons__stock--hidden',
          );
        }
      }

      #updateUrl(variant) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }

      #updateQuantity(delta) {
        if (!this.#quantityInput) return;

        const currentValue = Number(this.#quantityInput.value || 1);
        const nextValue = Math.max(1, currentValue + delta);
        this.#quantityInput.value = String(nextValue);
      }
    }

    if (!customElements.get(FORM_NAME)) {
      customElements.define(FORM_NAME, ProductForm);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-highlights-video"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const COMPONENT_NAME = 'product-highlights-video';
    const PLAY_ROOT_MARGIN = '200px';

    if (customElements.get(COMPONENT_NAME)) return;

    class ProductHighlightsVideo extends HTMLElement {
      #video = null;
      #observer = null;
      #selfPausing = false;
      #userPaused = false;

      connectedCallback() {
        this.#video = this.querySelector('video');

        if (!this.#video) return;

        /* The muted attribute is what the autoplay policy checks, but a
           browser restoring state on a back-navigation can leave the property
           unmuted — set both so play() is never blocked. */
        this.#video.muted = true;

        /* Controls are on, so the shopper can pause. Remember that and stop
           the observer from restarting the video behind their back. */
        this.#video.addEventListener('pause', this.#onPause);
        this.#video.addEventListener('play', this.#onPlay);
        this.#video.addEventListener('pointerdown', this.#onIntent);
        this.#video.addEventListener('keydown', this.#onIntent);

        if (document.readyState === 'complete') {
          this.#arm();
        } else {
          window.addEventListener('load', this.#arm, { once: true });
        }
      }

      disconnectedCallback() {
        window.removeEventListener('load', this.#arm);
        this.#observer?.disconnect();
        this.#observer = null;
        this.#video?.removeEventListener('pause', this.#onPause);
        this.#video?.removeEventListener('play', this.#onPlay);
        this.#video?.removeEventListener('pointerdown', this.#onIntent);
        this.#video?.removeEventListener('keydown', this.#onIntent);
      }

      /* Off-screen playback still decodes frames, so the observer stays
         connected to pause on the way back out. It starts after load so the
         file is not requested with the first paint. */
      #arm = () => {
        if (!this.isConnected || !this.#video) return;
        if (this.#observer) return;
        if (this.#prefersReducedMotion()) return;
        if (!('IntersectionObserver' in window)) return;

        this.#observer = new IntersectionObserver(
          (entries) => {
            const visible = entries.some((entry) => entry.isIntersecting);

            if (visible) {
              this.#play();
            } else {
              this.#pause();
            }
          },
          { rootMargin: PLAY_ROOT_MARGIN },
        );

        this.#observer.observe(this);
      };

      #onIntent = (event) => {
        if (
          event.type === 'keydown' &&
          event.key !== 'Enter' &&
          event.key !== ' '
        )
          return;

        this.#attachSources();
      };

      /* The pause event is queued, not synchronous, so the flag has to be
         cleared here rather than straight after the pause() call. */
      #onPause = () => {
        if (this.#selfPausing) {
          this.#selfPausing = false;
          return;
        }

        this.#userPaused = true;
      };

      #onPlay = () => {
        this.#userPaused = false;
      };

      #pause() {
        if (this.#video.paused) return;

        this.#selfPausing = true;
        this.#video.pause();
      }

      #prefersReducedMotion() {
        return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      }

      #attachSources() {
        if (this.#video.dataset.highlightsVideoLoaded === 'true') return;

        const data = this.#video.nextElementSibling;

        if (!(data instanceof HTMLScriptElement)) return;
        if (!data.matches('[data-highlights-video-sources]')) return;

        let sources = [];

        try {
          sources = JSON.parse(data.textContent || '[]');
        } catch {
          return;
        }

        if (!Array.isArray(sources)) return;

        for (const source of sources) {
          if (!source?.url) continue;

          const element = document.createElement('source');

          element.src = source.url;

          if (source.mime_type) element.type = source.mime_type;

          this.#video.append(element);
        }

        this.#video.dataset.highlightsVideoLoaded = 'true';
        this.#video.preload = 'auto';
        this.#video.load();
      }

      #play() {
        /* Once the shopper takes over with the controls, leave it alone —
           scrolling past and back shouldn't restart a video they paused. */
        if (this.#userPaused) return;

        this.#attachSources();

        this.#video.play().catch(() => {
          /* Autoplay refused (low power mode, policy) — poster and controls
             are still there, so the shopper can start it. */
        });
      }
    }

    customElements.define(COMPONENT_NAME, ProductHighlightsVideo);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  (() => {
    const CLEAR_SELECTOR = '[data-search-page-clear]';
    const INPUT_SELECTOR = '[data-search-page-input]';

    // Clearing empties the field and hands focus back, so a shopper can retype
    // without reaching for the mouse. It never navigates.
    document.addEventListener('click', (event) => {
      const clear = event.target.closest?.(CLEAR_SELECTOR);

      if (!clear) return;

      const input = clear.closest('form')?.querySelector(INPUT_SELECTOR);

      event.preventDefault();

      if (!input) return;

      input.value = '';
      clear.setAttribute('hidden', '');
      input.focus();
    });

    document.addEventListener('input', (event) => {
      const input = event.target.closest?.(INPUT_SELECTOR);

      if (!input) return;

      const clear = input.closest('form')?.querySelector(CLEAR_SELECTOR);

      clear?.toggleAttribute('hidden', input.value === '');
    });
  })();

  (() => {
    const COMPONENT_NAME = 'search-results';

    if (customElements.get(COMPONENT_NAME)) return;

    class SearchResults extends HTMLElement {
      #abortController = null;
      #fetchController = null;
      #isLoading = false;

      connectedCallback() {
        this.#abortController = new AbortController();

        this.addEventListener('click', this.#handleClick, {
          signal: this.#abortController.signal,
        });
      }

      disconnectedCallback() {
        this.#abortController?.abort();
        this.#abortController = null;
        this.#fetchController?.abort();
        this.#fetchController = null;
      }

      #handleClick = (event) => {
        const trigger = event.target.closest?.('[data-search-results-more]');

        if (!trigger) return;

        // Cmd/Ctrl/Shift/Alt-click and middle-click mean "open this URL", so
        // they are left to the browser rather than appended inline.
        if (
          event.defaultPrevented ||
          event.button !== 0 ||
          event.metaKey ||
          event.ctrlKey ||
          event.shiftKey ||
          event.altKey
        ) {
          return;
        }

        event.preventDefault();
        this.#loadMore(trigger);
      };

      async #loadMore(trigger) {
        const href = trigger.getAttribute('href');

        if (this.#isLoading || !href) return;

        this.#isLoading = true;
        trigger.setAttribute('aria-busy', 'true');
        this.#setError('');

        this.#fetchController?.abort();
        this.#fetchController = new AbortController();

        try {
          const response = await fetch(this.#buildUrl(href), {
            signal: this.#fetchController.signal,
          });

          if (!response.ok) {
            this.#setError(this.dataset.errorMessage ?? '');
            return;
          }

          this.#append(await response.text(), trigger);
        } catch (error) {
          // The click was intercepted, so a failed fetch has to say so — the
          // button stays in place and the next click retries.
          if (error?.name !== 'AbortError') {
            this.#setError(this.dataset.errorMessage ?? '');
          }
        } finally {
          this.#isLoading = false;
          trigger.removeAttribute('aria-busy');
        }
      }

      #setError(message) {
        const error = this.querySelector('[data-search-results-error]');

        if (!error) return;

        error.textContent = message;
        error.toggleAttribute('hidden', message === '');
      }

      // The href comes from Shopify's own pagination, so it already carries
      // q, type and options[prefix]; only section_id has to be added.
      #buildUrl(href) {
        const url = new URL(href, window.location.origin);

        url.searchParams.set('section_id', this.dataset.sectionId ?? '');

        return url.toString();
      }

      // Shopify builds the next page's URL from the request it just answered,
      // so the markup comes back carrying section_id. Left on the button, it
      // would open a bare section fragment in a new tab; #buildUrl re-adds it.
      #cleanUrl(href) {
        const url = new URL(href, window.location.origin);

        url.searchParams.delete('section_id');

        return `${url.pathname}${url.search}`;
      }

      #append(markup, trigger) {
        const parsed = new DOMParser().parseFromString(markup, 'text/html');
        const incomingList = parsed.querySelector('[data-search-results-list]');
        const list = this.querySelector('[data-search-results-list]');

        if (!incomingList || !list) return;

        const firstAdded = incomingList.firstElementChild;

        list.append(...incomingList.children);

        const incomingMore = parsed.querySelector('[data-search-results-more]');
        const nextHref = incomingMore?.getAttribute('href');

        if (nextHref) {
          trigger.setAttribute('href', this.#cleanUrl(nextHref));
        } else {
          trigger.remove();
        }

        // Keyboard and screen reader users land on the first new result rather
        // than at the top of the page. Product tiles sit in a plain wrapper and
        // need a tabindex first; page chips are anchors and already take focus.
        if (firstAdded instanceof HTMLElement) {
          if (firstAdded.tabIndex < 0) {
            firstAdded.setAttribute('tabindex', '-1');
          }

          firstAdded.focus({ preventScroll: true });
        }
      }
    }

    customElements.define(COMPONENT_NAME, SearchResults);
  })();

  (() => {
    const COMPONENT_NAME = 'search-tabs';

    if (customElements.get(COMPONENT_NAME)) return;

    const PROBE_TIMEOUT = 5000;
    const CACHE_PREFIX = 'roka:search-tabs-empty:';

    // The design draws no tab strip when nothing matched anywhere, but the
    // server cannot tell: a typed request counts only its own types, and
    // collections are absent from the `search` object. So the strip renders,
    // and this counts the other tabs before taking it away.
    //
    // Every failure path leaves it up. A shopper on an empty tab has no other
    // route to the tabs that did match, so a slow, blocked or malformed probe
    // must not be allowed to look like an empty catalogue.
    class SearchTabs extends HTMLElement {
      #fetchController = null;
      #timeoutId = null;

      connectedCallback() {
        if (!this.dataset.probeUrl) return;

        // A verdict already reached for this query is applied straight away,
        // so a repeat search — a back navigation, or the same term typed again
        // — does not paint a strip it is about to remove. The probe still runs
        // and puts the strip back if the answer has changed since.
        if (this.#readCache()) {
          this.#hide();
        }

        this.#probe();
      }

      disconnectedCallback() {
        this.#fetchController?.abort();
        this.#fetchController = null;
        this.#clearTimeout();
      }

      async #probe() {
        this.#fetchController?.abort();
        this.#fetchController = new AbortController();

        const controller = this.#fetchController;
        this.#timeoutId = setTimeout(() => controller.abort(), PROBE_TIMEOUT);

        try {
          const counts = await Promise.all([
            this.#countResults(controller),
            this.#countCollections(controller),
          ]);

          const isEmpty = counts.every((count) => count === 0);

          if (isEmpty) {
            this.#hide();
          } else {
            this.hidden = false;
          }

          this.#writeCache(isEmpty);
        } catch {
          this.hidden = false;
          this.#writeCache(false);
        } finally {
          this.#clearTimeout();
        }
      }

      // `[hidden]` takes the strip out of the box tree, so a shopper who had
      // tabbed into it loses focus to the document with nothing said. Move it
      // to the field first — the one control every branch of this page
      // renders, and where a fresh query gets typed — and say why.
      #hide() {
        if (this.hidden) return;

        if (this.contains(document.activeElement)) {
          // The page's own field is display: none below 768px and whenever
          // the header runs its stacked field, and focusing a hidden element
          // is a no-op that drops focus to the body. The heading is the
          // stable fallback; it takes focus only when asked.
          const input = this.#sibling('[data-search-page-input]');
          let target = input;

          if (!input || input.offsetParent === null) {
            target = this.#sibling('.search-page__heading');
            target?.setAttribute('tabindex', '-1');
          }

          target?.focus();
          this.#announce();
        }

        this.hidden = true;
      }

      #announce() {
        const announcer = this.#sibling('[data-search-tabs-announcer]');

        if (!announcer) return;

        announcer.textContent = this.dataset.removedMessage ?? '';
      }

      // Scoped to this section's content wrapper: a page can carry more than
      // one section, and the strip must not read another one's field.
      #sibling(selector) {
        return (this.parentElement ?? document).querySelector(selector);
      }

      // One un-typed request answers three tabs at once: that route populates
      // products, pages and articles, so its `results_count` covers all three.
      // When this page was itself rendered from an un-typed request the count
      // is already in the document, and the request is skipped entirely.
      async #countResults(controller) {
        if (this.dataset.totalFromDocument !== undefined) {
          return this.#readCount(
            this.parentElement ?? document,
            '[data-search-total]',
            'searchTotal',
          );
        }

        const url = new URL(this.dataset.probeUrl, window.location.origin);

        url.searchParams.set('section_id', this.dataset.sectionId ?? '');

        const fragment = await this.#fetchFragment(url, controller);

        return this.#readCount(fragment, '[data-search-total]', 'searchTotal');
      }

      // The same predictive request the Collections tab makes — the only
      // Shopify surface that returns collections for a query.
      async #countCollections(controller) {
        const url = new URL('/search/suggest', window.location.origin);

        url.searchParams.set('q', this.dataset.terms ?? '');
        url.searchParams.set(
          'section_id',
          this.dataset.collectionsSectionId ?? '',
        );
        url.searchParams.set('resources[type]', 'collection');
        url.searchParams.set(
          'resources[limit]',
          this.dataset.collectionsLimit ?? '10',
        );
        url.searchParams.set('resources[limit_scope]', 'each');

        const fragment = await this.#fetchFragment(url, controller);

        return this.#readCount(
          fragment,
          '[data-search-collections-results]',
          'resultCount',
        );
      }

      async #fetchFragment(url, controller) {
        const response = await fetch(url.toString(), {
          signal: controller.signal,
        });

        if (!response.ok) throw new Error(response.status.toString());

        return new DOMParser().parseFromString(
          await response.text(),
          'text/html',
        );
      }

      // A count that cannot be read is not a zero, so it throws and the strip
      // stays rather than reporting tabs the shopper cannot check.
      #readCount(fragment, selector, key) {
        const count = Number(fragment.querySelector(selector)?.dataset[key]);

        if (!Number.isFinite(count)) throw new Error(selector);

        return count;
      }

      #clearTimeout() {
        clearTimeout(this.#timeoutId);
        this.#timeoutId = null;
      }

      // The terms alone are not the query. Session storage outlives a market
      // or language switch, and the same words answer differently in each, so
      // a verdict reached in one market must not be applied in another — the
      // shopper would lose the strip for the whole probe window on a search
      // that does have results here.
      #cacheKey() {
        return `${CACHE_PREFIX}${this.dataset.cacheScope ?? ''}:${
          this.dataset.terms ?? ''
        }`;
      }

      // Session storage throws outright in some privacy modes, so every access
      // is guarded and a failure simply means no head start.
      #readCache() {
        try {
          return sessionStorage.getItem(this.#cacheKey()) === 'true';
        } catch {
          return false;
        }
      }

      #writeCache(isEmpty) {
        try {
          if (isEmpty) {
            sessionStorage.setItem(this.#cacheKey(), 'true');
          } else {
            sessionStorage.removeItem(this.#cacheKey());
          }
        } catch {
          // Nothing to do — the probe still decides this page load.
        }
      }
    }

    customElements.define(COMPONENT_NAME, SearchTabs);
  })();

  (() => {
    const COMPONENT_NAME = 'search-collections';

    if (customElements.get(COMPONENT_NAME)) return;

    class SearchCollections extends HTMLElement {
      #abortController = null;
      #fetchController = null;

      connectedCallback() {
        this.#abortController = new AbortController();

        this.addEventListener('click', this.#handleClick, {
          signal: this.#abortController.signal,
        });

        this.#load();
      }

      disconnectedCallback() {
        this.#abortController?.abort();
        this.#abortController = null;
        this.#fetchController?.abort();
        this.#fetchController = null;
      }

      #handleClick = (event) => {
        if (!event.target.closest?.('[data-search-collections-retry]')) return;

        this.#load();
      };

      async #load() {
        const terms = (this.dataset.terms ?? '').trim();

        if (terms === '') {
          this.#renderEmpty();
          return;
        }

        this.#setStatus(this.dataset.loadingMessage ?? '', false, false);

        this.#fetchController?.abort();
        this.#fetchController = new AbortController();

        try {
          const response = await fetch(this.#buildUrl(terms), {
            signal: this.#fetchController.signal,
          });

          // A failed request is not an empty result set: telling the shopper
          // no collections matched would be wrong, so it offers a retry.
          if (!response.ok) {
            this.#renderError();
            return;
          }

          this.#render(await response.text());
        } catch (error) {
          if (error?.name === 'AbortError') return;

          this.#renderError();
        }
      }

      // Same shape as assets/search-drawer.js — the only Shopify surface that
      // returns collections for a query, capped at 10 with no total.
      #buildUrl(terms) {
        const url = new URL('/search/suggest', window.location.origin);

        url.searchParams.set('q', terms);
        url.searchParams.set('section_id', this.dataset.sectionId ?? '');
        url.searchParams.set('resources[type]', 'collection');
        url.searchParams.set('resources[limit]', this.dataset.limit ?? '10');
        url.searchParams.set('resources[limit_scope]', 'each');

        return url.toString();
      }

      #render(markup) {
        const template = document.createElement('template');
        template.innerHTML = markup;

        const incoming = template.content.querySelector(
          '[data-search-collections-results]',
        );

        if (!incoming || Number(incoming.dataset.resultCount ?? 0) === 0) {
          this.#renderEmpty();
          return;
        }

        this.replaceChildren(incoming);
        this.#syncExplore(true);
        this.#restoreTabs();
      }

      // The probe and this fetch race the same endpoint, so one can flake
      // while the other succeeds: the probe reads zero, hides the strip and
      // caches the verdict, while this render lands real doorways under a
      // page with no tabs. Results in hand outrank a probe's reading — put
      // the strip back and clear the poisoned session verdict.
      #restoreTabs() {
        const tabs = (this.parentElement ?? document).querySelector(
          'search-tabs',
        );

        if (!tabs || !tabs.hidden) return;

        tabs.removeAttribute('hidden');

        try {
          // Mirrors SearchTabs' own key: prefix + cache scope + ':' + terms.
          sessionStorage.removeItem(
            `roka:search-tabs-empty:${tabs.dataset.cacheScope ?? ''}:${
              tabs.dataset.terms ?? ''
            }`,
          );
        } catch {
          // Session storage throws in some privacy modes; the un-hide above
          // already corrected the visible state.
        }
      }

      #renderEmpty() {
        this.#setStatus(this.dataset.emptyMessage ?? '', false, true);
        this.#syncExplore(false);
      }

      #renderError() {
        this.#setStatus(this.dataset.errorMessage ?? '', true, true);
      }

      // `show_explore` was decided server-side from the un-typed
      // `results_count`, which says nothing about collections — this tab's
      // real count only arrives here, after paint. So each settled fetch
      // corrects the explore group in both directions: real doorways displace
      // the cards, an empty tab earns them. An error corrects nothing, because
      // a failed request is not a count and the server state stands. Scoped to
      // the parent so another section's cards are never touched.
      #syncExplore(hasResults) {
        const explore = (this.parentElement ?? document).querySelector(
          '[data-search-explore]',
        );

        explore?.toggleAttribute('hidden', hasResults);
      }

      // `settled` is what swaps the skeleton for the message: while loading the
      // skeleton stands in for the panel, and only a terminal state — empty or
      // error — has anything to say that a skeleton cannot.
      #setStatus(message, canRetry, settled) {
        const status = this.querySelector('[data-search-collections-status]');
        const retry = this.querySelector('[data-search-collections-retry]');
        const announcer = this.querySelector(
          '[data-search-collections-announcer]',
        );

        if (status) {
          status.removeAttribute('hidden');
          status.textContent = message;
        }

        // The skeleton is decorative, so the live region is the only thing that
        // reports the loading state to assistive technology.
        if (announcer) {
          announcer.textContent = message;
        }

        retry?.toggleAttribute('hidden', !canRetry);
        this.toggleAttribute('data-settled', settled);
      }
    }

    customElements.define(COMPONENT_NAME, SearchCollections);
  })();

  } catch(e) { console.error(e); }
})();
})();
